import React, {useMemo} from 'react';
import {useRewards} from '@/hooks/useRewards';
import {REWARD_TYPES} from '@/utils/constants/rewardsConstants';
import {Divider} from '@/components/atoms';
import styles from '../RewardSetup/RewardSetup.module.scss';
import {
  AvailabilitySection,
  AdditionalAttributesSection
} from './ui-components';
import RewardPreview from '@/containers/Rewards/RewardSetup/ui-components/RewardPreview';

/**
 * RewardAttributes component - Step 3 of the reward creation process.
 * Contains preview message, availability dates, and additional attributes.
 *
 * @returns {JSX.Element} The rendered RewardAttributes component.
 */
const RewardAttributes = () => {
  const {formData, validation, handleFormChange, handleValidation} =
    useRewards();

  // Memoize whether to show preview message
  const shouldShowPreview = useMemo(() => {
    return Object.values(REWARD_TYPES).includes(formData.rewardType);
  }, [formData.rewardType]);

  return (
    <div className='flex flex-col gap-6'>
      {/* Combined Attributes Card */}
      <div
        className={`flex flex-col gap-6 rounded-lg p-6 ${styles.rewardSetup__card}`}>
        {/* Preview Message - Show for all reward types */}
        {shouldShowPreview && (
          <>
            <RewardPreview
              formData={formData}
              contentClassName='text-left text-base font-bold text-white'
              renderOnlyText={true}
            />
            <Divider className='mb-0 mt-0' />
          </>
        )}

        {/* Availability Section */}
        <AvailabilitySection
          formData={formData}
          handleFormChange={handleFormChange}
          handleValidation={handleValidation}
          isReadOnly={false}
        />

        {/* Divider */}
        <Divider className='mb-0 mt-0' />

        {/* Additional Attributes Section */}
        <AdditionalAttributesSection
          formData={formData}
          validation={validation}
          handleFormChange={handleFormChange}
          handleValidation={handleValidation}
          isReadOnly={false}
        />
      </div>
    </div>
  );
};

export default React.memo(RewardAttributes);
